import Box from '@mui/material/Box'
import { Modal, CircularProgress, Error, Generating } from '../components'
import texts from '../texts'
import styles from './summary.styles'

interface SummaryProps {
  title: string
  open: boolean
  onClose: () => void
  isLoading: boolean
  isGenerating?: boolean
  error: boolean
  data?: string | null
}

const Summary = ({
  title,
  open,
  onClose,
  isLoading,
  isGenerating,
  error,
  data,
}: SummaryProps) => {
  return (
    <Modal open={open} onClose={onClose} title={title}>
      {isLoading ? (
        <CircularProgress />
      ) : isGenerating ? (
        <Generating
          phrases={texts.getGeneratingPhrases('resumen')}
        />
      ) : error ? (
        <Error
          title={texts.getGenerationErrorTitle('resumen')}
          text={texts.getGenerationErrorSubtitle()}
        />
      ) : (
        <Box sx={styles.content}
          dangerouslySetInnerHTML={{
            __html: data as string,
          }}
        />
      )}
    </Modal>
  )
}

export default Summary
